// extracted by mini-css-extract-plugin
export default {"test":"Screenshot_test__88MD5","webcam":"Screenshot_webcam__9Cegk"};